module.exports = __webpack_public_path__ + "img/user-07.b73eecf0.png";